import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Style } from "@portal/lib/style/style";

export const StyledContactItem = Style(Flex, {
  borderBottom: "1px solid var(--gray-5)",

  ".contacts-container": {
    visibility: "visible",
    paddingBlock: "var(--space-12)",
    minHeight: "54px",
  },

  "&:hover .contacts-container": {
    background: "var(--gray-2)",
  },

  ".actions": {
    visibility: "hidden",
  },

  "&:hover .actions": {
    visibility: "visible",
  },
});
